<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ tel.Name }}</p>
    </div>
    <div class="bottom_content">
      <van-tabs
        v-model:active="tel.activeName"
        background="transparent"
        color="#b57e48"
        title-active-color="#b57e48"
      >
        <van-tab name="a" title="待沟通">
          <div v-if="tel.Bookings.length > 0" class="mk dgt">
            <div v-for="w in tel.Bookings" :key="w.BookingId" class="yydata">
              <div class="cirle"></div>
              <div>
                <p>
                  {{ w.BookingSource == '10' ? '预约人：' : '学员：' }}
                  <span>{{ w.CreatedByName ? w.CreatedByName : '--' }}</span>
                </p>
                <p>
                  预约时间：
                  <span>{{ dateFormat(w.BookingTime) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-else class="no-data">暂无预约~~</div>
        </van-tab>
        <van-tab name="b" title="预约失败">
          <div v-if="tel.FailedBookings.length > 0" class="mk yysb">
            <div
              v-for="y in tel.FailedBookings"
              :key="y.BookingId"
              class="yydata yysbdata"
            >
              <div class="cirle"></div>
              <div>
                <p>
                  {{ y.BookingSource == '10' ? '预约人：' : '学员：' }}
                  <span>{{ y.CreatedByName ? y.CreatedByName : '--' }}</span>
                </p>
                <p>
                  预约时间：
                  <span>{{ dateFormat(y.BookingTime) }}</span>
                </p>
                <div v-if="y.Remark" class="remark">
                  备注：
                  <span v-html="hhText(y.Remark)"></span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-data">暂无预约~~</div>
        </van-tab>
        <van-tab
          v-if="tel.SuccessfulBookings.length > 0"
          name="c"
          title="电话录音"
        >
          <div
            v-if="tel.SuccessfulBookings.length > 0"
            class="mk yp"
            style="padding-top: 0"
          >
            <ul>
              <div v-for="c in tel.SuccessfulBookings" :key="c.BookingId">
                <li @click="downloadFile(c.Record.FileUrl)">
                  <div class="yydata" style="width: 100%">
                    <div class="cirle"></div>
                    <div>
                      <p>
                        {{ c.BookingSource == '10' ? '预约人：' : '学员：' }}
                        <span>
                          {{ c.CreatedByName ? c.CreatedByName : '--' }}
                        </span>
                      </p>
                      <p>
                        预约时间：
                        <span>{{ dateFormat(c.BookingTime) }}</span>
                      </p>
                    </div>
                  </div>
                  <div v-if="c.Record" class="bottom_content_list">
                    <div class="xx">
                      <!-- <p class="data">{{ dateFormat(c.Record.UploadTime) }}</p> -->
                      <audio controls :src="api.FileHost + c.Record.FileUrl">
                        您的浏览器不支持 audio 元素。
                      </audio>
                      <div v-if="c.Record.Remark" class="dx">
                        备注：
                        <span v-html="hhText(c.Record.Remark)"></span>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
          </div>
          <div v-else class="no-data">暂无预约~~</div>
        </van-tab>
      </van-tabs>
      <!-- <van-empty description="暂无预约~~" image-size="60" /> -->
    </div>
    <!-- <div class="bottom_btn" @click="myAsk">
      <p>我要提问</p>
    </div> -->
  </div>
  <!-- <div v-if="tel.length == '0'" class="list_box">
    <div class="top_tit">
      <div class="line"></div>
      <p>电话沟通</p>
    </div>
    <div class="bottom_content">
      <van-empty description="暂无电话沟通" image-size="40" />
    </div>
  </div> -->
</template>

<script>
  import { hhText } from '@/utils/index'
  import { ref, onActivated, onDeactivated, onMounted, watch } from 'vue'
  import router from '@/router'
  import { copyText } from '../../../utils/index'
  import { dateFormat } from '@/utils/filters'
  import api from '@/api'
  export default {
    props: {
      // eslint-disable-next-line vue/require-default-prop
      tel: {
        type: Object,
      },
    },
    setup(props) {
      // const telDtaa = ref([
      //   {
      //     Bookings: [], 已预约沟通
      //     FailedBookings: [], 失败的预约
      //     ModuleCode: 'PhoneCommunication',
      //     ModuleInstanceId: '1519510448792277020',
      //     Name: '电话沟通',
      //     Sort: 2,
      //     SuccessfulBookings: [], 完成的预约
      //     Visible: true,
      //   },
      // ])
      const activeName = ref('a')
      const downloadFile = (url) => {
        window.open(api.FileHost + url)
      }
      onMounted(() => {
        props.tel.activeName = 'a'
      })
      return { activeName, downloadFile, api, dateFormat, hhText }
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    .mk {
      padding-top: 15px;
      .yydata {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin: 4px 0 8px 0;
        padding-bottom: 8px;
        border-bottom: 1px dashed #ccc;
        .cirle {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #28daad;
          margin-right: 10px;
        }
        p {
          font-size: 14px;
          color: #4f515f;
          span {
            font-size: 14px;
            color: #888;
          }
        }
      }
      .yydata:last-child {
        border: none;
      }
      .yysbdata {
        .cirle {
          background-color: #ca1139;
        }
        p {
          font-size: 14px;
          color: #4f515f;
          span {
            font-size: 14px;
            color: #888;
          }
        }
      }
      ul {
        li {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-bottom: 16px;
          border-bottom: 1px solid #e4e5ea;
          padding-top: 16px;
          .xx {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .tit {
              font-size: 14px;
              font-weight: bold;
            }
            .dx,
            .data {
              font-size: 12px;
              color: #888;
              margin-bottom: 12px;
              width: 278px;
            }
            .dx {
              margin-top: 10px;
            }
          }
          .arrowIcon {
            width: 24px;
          }
          .bottom_content_list {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            .icon_box {
              background-color: #454976;
              width: 28px;
              height: 28px;
              border-radius: 4px;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }
            img {
              width: 12px;
              height: 12px;
            }
            p {
              font-size: 15px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              margin-left: 14px;
            }
          }
        }
        li:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .remark {
    color: #999;
    font-size: 12px;
    margin-top: 6px;
  }
  .no-data {
    text-align: center;
    padding: 20px;
    font-size: 12px;
    color: #888;
  }
</style>
